import './checkout';
import './journey_search';
import stimulus from './stimulus';
import AutocompleteController from './autocomplete_controller';
import BlockingLoadingIndicatorController from './blocking_loading_indicator_controller';
import FilterController from './filter_controller';
import PassengersController from './passengers_controller';
import SupportButtonController from './support_button_controller';
import TurboFrameFallbackController from './turbo_frame_fallback_controller';
import TurboStreamLoaderController from './turbo_stream_loader_controller';

stimulus.register('autocomplete', AutocompleteController);
stimulus.register('blocking-loading-indicator', BlockingLoadingIndicatorController);
stimulus.register('filter', FilterController);
stimulus.register('passengers', PassengersController);
stimulus.register('support-button', SupportButtonController);
stimulus.register('turbo-frame-fallback', TurboFrameFallbackController);
stimulus.register('turbo-stream-loader', TurboStreamLoaderController);
